export const isWebView = (viewType: string): boolean => {
    return viewType == 'android' || viewType == 'ios' || viewType === 'MerchantAndroid';
};

export const isHeaderVisible = (viewType: string): boolean => {
    return !(viewType == 'android' || viewType == 'ios');
};
